import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpService } from './http.service';
import { DivisionDistrictMap } from '../../../interfaces/masters/division-district-map';

@Injectable()
export class DivisionDistrictMapApi {

  constructor(private api: HttpService) { }

  list(url: string): Observable<any> {
    return this.api.get(url, {
      headers: {
        'Accept': 'application/vnd.ezovion.hateoas+json',
        'Content-Type': 'application/json',
      },
    });
  }

  getById(url: string): Observable<DivisionDistrictMap> {
    return this.api.get(url, {
      headers: {
        'Accept': 'application/vnd.ezovion.hateoas+json',
        'Content-Type': 'application/json',
      },
    });
  }

  add(url: string, data: DivisionDistrictMap): Observable<any> {
    return this.api.post(url, data, {
      headers: {
        'Accept': 'application/vnd.ezovion.hateoas+json',
        'Content-Type': 'application/json',
      },
    });
  }

  update(url: string, data: DivisionDistrictMap): Observable<any> {
    return this.api.put(url, data, {
      headers: {
        'Accept': 'application/vnd.ezovion.hateoas+json',
        'Content-Type': 'application/json',
      },
    });
  }

}
